class MyCustomElement extends HTMLElement {
    constructor() {
        super();
        this.views = 0;
        this.isBold = false;
        this.widgetPadding = '10px';
        this.borderSize = '1px';
        this.borderColor = '#333';
        this.backgroundColor = '#FFFFFF';
        this.borderRadius = '8px';
        this.shadowIntensity = '2px';
        this.fontSize = '18px';

        // Icon Design
        this.iconSelection = 'none';
        this.iconColor = 'red';
        this.iconPosition = 'left';
        this.displayTemplate = "🔥 Hurry! Already viewed by {views} shoppers today!";
        this.primaryColor = '#333';
        this.primaryStyle = 'Arial';

        // General Settings
        this.widgetActivation = false;
        this.uniqueVisitors = true;

        // Behavioral Settings
        this.countingWindow = 'from_start';
        this.minViewsThreshold = 1;

        // Text Alignment
        this.textAlign = 'center';
    }

    connectedCallback() {
        // console.log("hello callback!");
        this.renderWidget();
        // // console.log("connectedCallback", this.views, this.widgetActivation, this.widgetActivation && this.views > 0);
        // if(this.widgetActivation && this.views > 0) {
        //     this.renderWidget();
        // }
        // else {
        //     const widgetWrapper = this.querySelector('#widget-wrapper');
        //     if(widgetWrapper) {
        //         widgetWrapper.style.display = 'none';
        //     }
        // }
    }

    getDynamicText() {
        let container = document.createElement('h1');
        container.id = 'dynamic-header';
        // Apply styles to the container
        container.style.position = 'relative';
        container.style.zIndex = '1';
        container.style.width = '100%';
        container.style.textAlign = this.textAlign; // Sets the text alignment dynamically
        container.style.fontSize = this.fontSize; // Set font size dynamically from `this.fontSize`
        container.style.margin = '0';
        container.style.padding = '0 30px';  // Provides padding to keep text away from the sides
        container.style.fontFamily = this.primaryStyle;
        container.style.color = this.primaryColor;
        container.style.fontWeight = this.toBoolean(this.isBold) ? 'bold' : 'normal';

        // Split the display template wherever '{views}' appears
        const parts = this.displayTemplate.split('{views}');

        // Iterate over parts and construct the text nodes and views spans
        parts.forEach((part, index) => {
            // Add the text part before 'views'
            if (part) {
                container.appendChild(document.createTextNode(part));
            }

            // Insert the 'views' span if it's not the last part
            if (index < parts.length - 1) {
                const viewsSpan = document.createElement('span');
                viewsSpan.className = 'views-span'; // Use class instead of id to handle multiples
                viewsSpan.textContent = this.views; 
                container.appendChild(viewsSpan);
            }
        });

        return container;
    }

    getIconClass(selection) {
        const iconClassMap = {
            'eye': 'fa-eye',
            'heart': 'fa-heart',
            'star': 'fa-star',
            'shopping-cart': 'fa-shopping-cart',
            'fire': 'fa-fire',
            'users': 'fa-users'
        };
        return iconClassMap[selection] || iconClassMap['heart']; // default to 'heart' if no match
    }

    getIconHtml() {
        let icon = document.createElement('i');
        let selectedIconClass = this.getIconClass(this.iconSelection);
        icon.className = `fa ${selectedIconClass}`;
        icon.style.color = this.iconColor; 
        icon.style.fontSize = '24px';
        icon.style.display = this.iconSelection !== 'none' ? '' : 'none';
        return icon;
    }

    renderWidget() {
        const styleLink = document.createElement('link');
        styleLink.rel = 'stylesheet';
        styleLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css';
        this.appendChild(styleLink);

        const wrapper = document.createElement('div');
        wrapper.id = 'widget-wrapper';
        wrapper.style.padding = this.widgetPadding;
        wrapper.style.backgroundColor = this.backgroundColor;
        wrapper.style.borderRadius = this.borderRadius;
        wrapper.style.border = `${this.borderSize} solid ${this.borderColor}`;
        wrapper.style.boxShadow = `0 ${this.shadowIntensity} rgba(0,0,0,0.1)`;
        // console.log('this.views:', this.views);
        // console.log("wrapper.style.display", this.toBoolean(this.widgetActivation), parseInt(this.views, 10),  ">=", parseInt(this.minViewsThreshold, 10));
        wrapper.style.display = (this.toBoolean(this.widgetActivation) && parseInt(this.views, 10) >= parseInt(this.minViewsThreshold, 10)) ? '' : 'none';
        const layoutContainer = document.createElement('div');
        layoutContainer.id = 'layout-container';
        layoutContainer.style.display = 'flex';
        layoutContainer.style.alignItems = 'center';
        layoutContainer.style.justifyContent = 'center';
        layoutContainer.style.position = 'relative';
        layoutContainer.style.width = '100%';
        layoutContainer.style.height = '100%';
        // layoutContainer.style.minWidth = '300px';
        // layoutContainer.style.justifyContent = this.textAlign.toLowerCase();
        const textContainer = this.getDynamicText();
        const icon = this.getIconHtml();
        icon.id = 'icon';
        layoutContainer.appendChild(textContainer);
        layoutContainer.appendChild(icon);
        wrapper.appendChild(layoutContainer);
        this.appendChild(wrapper);
        this.updateIcon();
        // console.log("this.innerHTML:", this.innerHTML);
    }

    static get observedAttributes() {
        return [
            'views', 'border-color', 'background-color', 'widget-padding',
            'border-radius', 'shadow-intensity', 'font-size', 'icon-selection',
            'icon-color', 'icon-position', 'display-template', 
            'primary-style', 'primary-color', 'widget-activation', 'unique-visitors', 
            'counting-window', 'min-views-threshold', 'text-align', 'is-bold', 'border-size'
        ];
    }

    dashToCamel(str) {
        return str.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
    }

    attributeChangedCallback(name, oldValue, newValue) {
        // console.log("attributeChangedCallback", name, oldValue, newValue);
        if (oldValue !== newValue) {
            // // console.log("attributeChangedCallback", name, "propertyName", newValue, this[propertyName]);
            // Delay execution slightly to allow the DOM to update
            setTimeout(() => {
                const propertyName = this.dashToCamel(name);
                this[propertyName] = newValue;
                if(propertyName == 'views') {
                    // console.log('!!!', this[propertyName], newValue);
                }
                // // console.log("attributeChangedCallback", name, "propertyName", newValue, this[propertyName]);
                this.applyAttributeChanges(propertyName, oldValue, newValue);
            }, 0); // setTimeout with 0 ms still pushes execution to the edge of the event loop
        }
    }

    updateIcon() {
        const icon = this.querySelector('#icon');
        const header = this.querySelector('#dynamic-header');
        if(icon) {
            // Check if icon should be displayed and update classes accordingly
            if (this.iconSelection !== 'none') {
                icon.className = `fa ${this.getIconClass(this.iconSelection)}`;
                icon.style.display = ''; // Show icon
                icon.style.color = this.iconColor; // Update icon color
                icon.style.position = 'absolute';
                icon.style.top = '50%';
                icon.style.transform = 'translateY(-50%)';

                // Positioning the icon to the left or right
                if (this.iconPosition === 'left') {
                    icon.style.left = 'calc(5px + 0%)'; // Ensure it's always offset
                    icon.style.right = 'auto';
                } else if (this.iconPosition === 'right') {
                    icon.style.right = 'calc(5px + 0%)'; // Ensure it's always offset
                    icon.style.left = 'auto';
                }
            } else {
                icon.style.display = 'none'; // Hide icon if not needed
            }
        }
        
        if(header) {
            // Adjust text alignment in the header according to this.textAlign
            if (this.textAlign) {
                header.style.textAlign = this.textAlign;
            } else {
                header.style.textAlign = 'center'; // Default alignment if not specified
            }

            // Maintain consistent padding regardless of the icon
            header.style.paddingLeft = '30px';
            header.style.paddingRight = '30px';
        }
        // // console.log("icon:", this.innerHTML);
    }

    toBoolean(value) {
        if (typeof value === 'boolean') {
            return value;
        } else if (typeof value === 'string') {
            return value.toLowerCase() === 'true';
        }
        console.warn('Expected boolean value, received:', value);
        return false;
    }

    applyAttributeChanges(propertyName, oldValue, newValue) {
        const widgetWrapper = this.querySelector('#widget-wrapper');
        const layoutContainer = this.querySelector('#layout-container');
        const dynamicHeader = this.querySelector('#dynamic-header');
        const viewsSpans = this.querySelectorAll('.views-span');

        // Ensure the value is in proper string format when required
        const valueString = typeof newValue === 'number' ? newValue.toString() : newValue;

        // console.log("applyAttributeChanges", propertyName, valueString);

        switch (propertyName) {
            case 'iconSelection':
            case 'iconColor':
            case 'iconPosition':
                // setTimeout(() => {
                this.updateIcon();
                // }, 0);
                break;

            case 'fontSize':
                // fontSize should include 'px' unless already specified
                if (dynamicHeader) {
                    dynamicHeader.style.fontSize = valueString.includes('px') ? valueString : valueString + 'px';
                }
                break;
            case 'displayTemplate':
                if (layoutContainer) {
                    let headerElement = layoutContainer.querySelector('#dynamic-header');
                    if (headerElement) {
                        layoutContainer.removeChild(headerElement);  // Remove the specific element
                    }
                    layoutContainer.appendChild(this.getDynamicText());  // Add the updated text container
                }
                break;
            case 'views':
                // Update text content directly for views
                // console.log("views update!", (widgetWrapper), this.toBoolean(this.widgetActivation), parseInt(this.views, 10), this.minViewsThreshold);
                if (widgetWrapper && widgetWrapper) {
                    widgetWrapper.style.display = (this.toBoolean(this.widgetActivation) && parseInt(this.views, 10) >= this.minViewsThreshold) ? '' : 'none';
                }
                if (viewsSpans.length) {
                    viewsSpans.forEach(span => span.textContent = newValue); // newValue can be a number here
                }

                break;
            case 'borderSize':
                if (widgetWrapper) {
                    const borderStyle = "solid";  // You might already have this dynamic or defaulted elsewhere
                    const currentColor = widgetWrapper.style.borderColor || '#333';  // Default or previously set
                    const cssValue = newValue.toString().includes('px') ? newValue : `${newValue}px`;
                    widgetWrapper.style.border = `${cssValue} ${borderStyle} ${currentColor}`;
                }
                break;
            case 'widgetPadding':
            case 'borderRadius':
            case 'shadowIntensity':
                if (widgetWrapper) {
                    const cssValue = newValue.toString().includes('px') ? newValue : `${newValue}px`;
                    if (propertyName === 'shadowIntensity') {
                        widgetWrapper.style.boxShadow = `0 ${cssValue} rgba(0, 0, 0, 0.1)`;
                    } else {
                        widgetWrapper.style[propertyName] = cssValue;
                    }
                }
                break;
            case 'borderColor':
                if (widgetWrapper && widgetWrapper.style.border) {
                    // Extract the size and style by capturing digits followed by 'px' and the subsequent word (style)
                    const borderRegex = /^(\d+px)\s+(\w+)\s+(.*)$/;
                    const borderMatch = widgetWrapper.style.border.match(borderRegex);

                    if (borderMatch) {
                        // Construct new border string with new color value
                        const newSizeStyle = `${borderMatch[1]} ${borderMatch[2]}`; // Size and style
                        const newColor = newValue;  // New color value
                        widgetWrapper.style.border = `${newSizeStyle} ${newColor}`;
                    } else {
                        console.warn('Failed to parse border style:', widgetWrapper.style.border);
                    }
                }
                break;
            case 'backgroundColor':
                // Colors typically don't need 'px' but checking type for safety and consistency.
                if (widgetWrapper) {
                    widgetWrapper.style[propertyName] = valueString;
                }
                break;

            case 'primaryColor':
                // Directly assigning the color to the text element
                if (dynamicHeader) {
                    dynamicHeader.style.color = valueString;
                }
                break;

            case 'primaryStyle':
                // Font style direct assignment
                if (dynamicHeader) {
                    dynamicHeader.style.fontFamily = valueString;
                }
                break;

            case 'textAlign':
                // textAlign handles raw string well, but safe conversion assures no issues
                if (dynamicHeader) {
                    dynamicHeader.style.textAlign = valueString;
                }
                break;

            case 'isBold':
                // // console.log('isBold', dynamicHeader);
                if (dynamicHeader) {
                    dynamicHeader.style.fontWeight = this.toBoolean(newValue) ? 'bold' : 'normal';
                }
                break;
            case 'widgetActivation':
                // Handle widget activation/deactivation

                if (widgetWrapper) {
                    widgetWrapper.style.display = (this.toBoolean(newValue) && parseInt(this.views, 10) >= this.minViewsThreshold) ? '' : 'none';
                }
                break;

            // Properties that don't require DOM updates (for documentational purposes)
            case 'minViewsThreshold':
            case 'countingWindow':
            case 'uniqueVisitors':
                // Handle internally, no DOM updates needed
                break;

            default:
                console.warn(`No handler for property: ${propertyName}`);
                break;
        }
        // console.log("Updated innerHTML:", this.innerHTML);
    }
}

customElements.define('viewboost-element', MyCustomElement);
